class RmBannerSlider extends HTMLElement {
  constructor() {
    super();

    this.initSwiper();
    this.addSafariResizeWatcher();
  }

  initSwiper() {

    const swiper = new Swiper('.swiper', {
      
      direction: 'horizontal',
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 3000,
      },

      autoHeight: true,

      // preloadImages: false,
      // lazy: {
      //   loadPrevNext: true,
      // 	loadPrevNextAmount: 1,
      // },

      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: ".swiper-pagination",
      },
    
    });

  }

  addSafariResizeWatcher() {
    let isSafari =
    navigator.vendor &&
    navigator.vendor.indexOf("Apple") > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf("CriOS") == -1 &&
    navigator.userAgent.indexOf("FxiOS") == -1;

    if (isSafari) {
      // Trigger Webkit engine after browser resize (Safari)
      // https://github.com/ausi/respimagelint/issues/31#issuecomment-420355534
      // Needed so the different image sizes load correctly on window resize in Safari
      window.addEventListener("resize", function() {
        let imgs = this.querySelectorAll("picture img");
        for (let i = 0; i < imgs.length; i++) {
          imgs[i].src += "";
        }
      }.bind(this));
    }
  }
  
}
  
customElements.define('rm-banner-slider', RmBannerSlider);